import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts);

const RadarChart = ({ data = [], labels = [] }) => {
  const options = {
    credits: {
      enabled: false,
    },
    colors: ['#4b8c6f80'],
    chart: {
      polar: true,
    },
    title: {
      text: '',
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
    },
    xAxis: {
      tickInterval: 45,
      min: 0,
      max: 360,
      labels: {
        formatter: function () {
          return labels[this.value / 45];
        },
      },
    },
    yAxis: {
      min: 0,
      labels: {
        enabled: false,
      },
    },
    plotOptions: {
      series: {
        pointStart: 0,
        pointInterval: 45,
      },
    },
    tooltip: {
      backgroundColor: '#fff',
      borderRadius: 4,
      borderColor: '#ddd',
      borderWidth: 1,
      shadow: false,
      shape: 'rect',
      distance: 24,
      pointFormatter: function () {
        return `<b>${this.y}</b><br/>${labels[this.index]}`;
      },
      headerFormat: '',
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        type: 'area',
        name: 'Area',
        data,
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default RadarChart;
